<template>
    <div class="auction-detail-timer">
        <div class="auction-detail-timer__block">
            <div class="auction-detail-timer__label">{{ time.days }}</div>
            <div class="auction-detail-timer__value">дней</div>
        </div>

        <div class="auction-detail-timer__block">
            <div class="auction-detail-timer__label">{{ time.hours }}</div>
            <div class="auction-detail-timer__value">часов</div>
        </div>

        <div class="auction-detail-timer__block">
            <div class="auction-detail-timer__label">{{ time.minutes }}</div>
            <div class="auction-detail-timer__value">мин.</div>
        </div>

        <div class="auction-detail-timer__block">
            <div class="auction-detail-timer__label">{{ time.seconds }}</div>
            <div class="auction-detail-timer__value">сек.</div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { reactive, onMounted, onUnmounted, defineProps } from 'vue';

    const props = defineProps({
        secondToEnd: {
            type: Number,
            required: true,
        },
    });

    const time = reactive({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
    });

    let interval: number | undefined;

    function calculateTime(): void {
        const diff = props.secondToEnd;

        if (diff <= 0) {
            time.days = '00';
            time.hours = '00';
            time.minutes = '00';
            time.seconds = '00';
            clearInterval(interval);

            return;
        }

        time.days = String(Math.floor(diff / (60 * 60 * 24))).padStart(2, '0');
        time.hours = String(Math.floor((diff / (60 * 60)) % 24)).padStart(2, '0');
        time.minutes = String(Math.floor((diff / 60) % 60)).padStart(2, '0');
        time.seconds = String(Math.floor((diff) % 60)).padStart(2, '0');
    }

    onMounted(() => {
        calculateTime();
        interval = setInterval(calculateTime, 1000);
    });

    onUnmounted(() => {
        clearInterval(interval);
    });
</script>

<style scoped lang="scss">
    @use './ViewAuctionTimer.scss' as *;
</style>
